<template>
  <div class="taskFormBlock">
    <form @submit.prevent="createTask">
      <input type="text" v-model="title" maxlength="40" placeholder="Task title" class="inputTask"/>
      <button type="submit" class="createBtn" @click="createTask">Create</button>
    </form>
  </div>
</template>

<script>
export default {
  name: "TaskForm",
  data() {
    return {
      title: "",
      tasks: [],
    };
  },

  methods: {
    createTask() {
      if (this.title.trim() !== "") {
        this.$store.commit("createTask", {title: this.title});
        this.tasks.push({title: this.title});
        this.title = "";
      }
    },
    loadTasks() {
      const tasks = localStorage.getItem("tasks");
      if (tasks) {
        this.tasks = JSON.parse(tasks);
      }
    },
  },
  created() {
    this.loadTasks();
  },
};

</script>

<style>
.taskFormBlock {
  display: flex;
  min-height: 50px;
  align-items: center;
}

.inputTask {
  position: relative;
  font-size: 1.5em;
  background: linear-gradient(21deg, #10abff, #1beabd);
  padding: 3px;
  display: inline-block;
  border-radius: 9999em;
  margin-right: 25px;

  *:not(span) {
    position: relative;
    display: inherit;
    border-radius: inherit;
    margin: 0;
    border: none;
    outline: none;
    padding: 0 .325em;
    z-index: 1;

    &:focus + span {
      opacity: 1;
      transform: scale(1);
    }
  }
}

.createBtn {

  display: inline-block;
  outline: 0;
  border: 0;
  cursor: pointer;
  font-weight: 600;
  color: #fff;
  font-size: 14px;
  height: 38px;
  padding: 8px 24px;
  border-radius: 50px;
  background-image: linear-gradient(180deg, #7c8aff, #3c4fe0);
  box-shadow: 0 4px 11px 0 rgb(37 44 97 / 15%), 0 1px 3px 0 rgb(93 100 148 / 20%);
  transition: all .2s ease-out;

  :hover {
    box-shadow: 0 8px 22px 0 rgb(37 44 97 / 15%), 0 4px 6px 0 rgb(93 100 148 / 20%);
  }
  :after{
  }

}
</style>